export const environment = {
    production: false,
    nyemURL: 'https://gkenypa-emqa-sdl-sso.c3iot.ai/',
    NYPAStaticPage:'https://www-qa.nypa.gov/application-selection'
};